//Define root of api
// export const APIROOT = 'http://10.0.20.75:3030';
// export const APIROOT = 'http://127.0.0.1:3030';
// export const APIROOT = 'http://10.0.20.84';

export const APIROOT = 'http://41.72.149.242/multilayer';
